// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LULxCEE2Qs7qIYOBrKMl {
  height: 60px;
  border-radius: 24px;
  border: 1px solid var(--grey-color-300);
  background-color: var(--grey-color-200);
  padding: 16px;
  color: var(--grey-color-90);
  font-family: var(--font-stack-full-heavy);
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  line-height: 24px; /* 150% */
}

.fZZCjv0AxLUYfflqKsIK {
  color: var(--grey-color-90);
  margin: 24px 0;
  /* var(--font-stack-full-regular)/18 Book */
  font-family: var(--font-stack-full-book);
  font-size: 18px;
  font-style: normal;
  font-weight: 350;
  line-height: 24px; /* 133.333% */
  width: 630px;
}

.IiYBf2cBYGIRCQmbdq7w {
  margin-top: 16px;
}

.iQEdGfyR0tNMq6gcowen {
  float: right;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: relative;
  right: -8px;
}

.OfGH5Xi0V_2BF8thLePw {
  display: none;
}

.sKgGZW7JMyVf0Mgw95gQ {
  background-color: var(--grey-color-10);
  border-radius: 2px;
  padding: 4px 5px 0;
  height: 24px;
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  color: var(--grey-color-70);
}

.UBJGs1FoT8R3Jm6HOgii {
  width: 630px;
}

.T9i1JiRyMTIoB9klP3U2 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 630px;
  margin-bottom: 18px;
}

.byahJmw8hUC_rmg4tsuF {
  width: 100%;
}

.UlB5YvBbbxFBoPuBhScE {
  margin: 24px 0;
  width: 630px;
}

.FNS_g_1k9c1J_n34Bdcs {
  margin: 16px 0;
  max-width: 630px;
}

.EC3ot3gHR3yJ506Y73cU {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 614px;
  padding: 16px;
  align-self: stretch;
  border-radius: 20px;
  border: 1px solid var(--orange-color-500);
  background-color: var(--grey-color-10);
  box-shadow: 0 -1px 2px 0 rgba(15, 20, 31, 0.12), 0 4px 16px 0 rgba(15, 20, 31, 0.16);
}

._1jdbylUxRFiZLUWh7RR {
  color: var(--grey-color-90);
  font-family: var(--font-stack-full-book);
  font-size: 16px;
  font-style: normal;
  font-weight: 350;
  line-height: 24px;
}

.vhKBV1UaLxmCV5NhQdu9 {
  margin-top: 12px;
}

.VhjrTvREEwW_CuI8heh9 {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: var(--grey-color-90);
  font-family: var(--font-stack-full-book);
  font-size: 16px;
  font-style: normal;
  font-weight: 350;
  line-height: 24px;
}

.dlfJ8wBBMY9NxX_SOnF2 {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.M7wy0pA46KYaaUVA2XQz {
  display: flex;
  align-items: flex-start;
  margin-top: 24px;
  align-self: stretch;
  width: 630px;
}

.pPMXNOU_GjUMzJCxszHu {
  display: flex;
  height: 36px;
  align-items: center;
  gap: 16px;
  flex: 1 0 0;
}

.gF9fc52gP4UwAGWugM46 {
  display: flex;
  height: 36px;
  align-items: center;
  gap: 4px;
}

.yx4CpfhSf7zc8hTlrNE7 {
  display: flex;
  height: 36px;
  align-items: center;
  gap: 4px;
}

.kDIfsdMBs3GtraBBgmbI {
  background-color: var(--grey-gradient-start-color-10);
  color: var(--grey-color-90);
}

.QX82wSWxMtEE34cNCaLQ {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
}

.bcvyCYmNgd73i9CWhs3x {
  color: var(--navbar-text-color);
  border: 1px solid var(--navbar-text-color) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Filters/FilterSelectPanel.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,mBAAA;EACA,uCAAA;EACA,uCAAA;EACA,aAAA;EACA,2BAAA;EACA,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;AACF;;AAEA;EACE,2BAAA;EACA,cAAA;EACA,2CAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,YAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,sCAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,2BAAA;AACF;;AAKA;EACE,YAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;AAFF;;AAKA;EACE,WAAA;AAFF;;AAKA;EACE,cAAA;EACA,YAAA;AAFF;;AAKA;EACE,cAAA;EACA,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yCAAA;EACA,sCAAA;EACA,oFAAA;AAFF;;AAMA;EACE,2BAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAHF;;AAMA;EACE,gBAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,2BAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAHF;;AAMA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AAHF;;AAMA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AAHF;;AAMA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,QAAA;AAHF;;AAMA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,QAAA;AAHF;;AAMA;EACE,qDAAA;EACA,2BAAA;AAHF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AAFF;;AAIA;EACE,+BAAA;EACA,qDAAA;AADF","sourcesContent":[".dropdownTitle {\n  height: 60px;\n  border-radius: 24px;\n  border: 1px solid var(--grey-color-300);\n  background-color: var(--grey-color-200);\n  padding: 16px;\n  color: var(--grey-color-90);\n  font-family: var(--font-stack-full-heavy);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 800;\n  line-height: 24px; /* 150% */\n}\n\n.instructions {\n  color: var(--grey-color-90);\n  margin: 24px 0;\n  /* var(--font-stack-full-regular)/18 Book */\n  font-family: var(--font-stack-full-book);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 350;\n  line-height: 24px; /* 133.333% */\n  width: 630px;\n}\n\n.navigationContainer {\n  margin-top: 16px;\n}\n\n.carets {\n  float: right;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  position: relative;\n  right: -8px;\n}\n\n.hidden {\n  display: none;\n}\n\n.count {\n  background-color: var(--grey-color-10);\n  border-radius: 2px;\n  padding: 4px 5px 0;\n  height: 24px;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 500;\n  color: var(--grey-color-70);\n}\n\n.children {\n}\n\n.dynamicFiltersContainer {\n  width: 630px;\n}\n\n.dropdownContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 630px;\n  margin-bottom: 18px;\n}\n\n.dropdownHeader {\n  width: 100%;\n}\n\n.cautionCardWrapper {\n  margin: 24px 0;\n  width: 630px;\n}\n\n.infoContainer {\n  margin: 16px 0;\n  max-width: 630px;\n}\n\n.cautionCard {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-width: 614px;\n  padding: 16px;\n  align-self: stretch;\n  border-radius: 20px;\n  border: 1px solid var(--orange-color-500);\n  background-color: var(--grey-color-10);\n  box-shadow: 0 -1px 2px 0 rgba(15, 20, 31, 0.12),\n    0 4px 16px 0 rgba(15, 20, 31, 0.16);\n}\n\n.cautionDescription {\n  color: var(--grey-color-90);\n  font-family: var(--font-stack-full-book);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 350;\n  line-height: 24px;\n}\n\n.checkboxContainer {\n  margin-top: 12px;\n}\n\n.checkboxLabel {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  color: var(--grey-color-90);\n  font-family: var(--font-stack-full-book);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 350;\n  line-height: 24px;\n}\n\n.checkbox {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.buttonContainer {\n  display: flex;\n  align-items: flex-start;\n  margin-top: 24px;\n  align-self: stretch;\n  width: 630px;\n}\n\n.leftButtonContainer {\n  display: flex;\n  height: 36px;\n  align-items: center;\n  gap: 16px;\n  flex: 1 0 0;\n}\n\n.rightButtonContainer {\n  display: flex;\n  height: 36px;\n  align-items: center;\n  gap: 4px;\n}\n\n.backButtonContainer {\n  display: flex;\n  height: 36px;\n  align-items: center;\n  gap: 4px;\n}\n\n.backButton {\n  background-color: var(--grey-gradient-start-color-10);\n  color: var(--grey-color-90);\n}\n.continueButtonContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 5px;\n}\n.continueButton {\n  color: var(--navbar-text-color);\n  border: 1px solid var(--navbar-text-color) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdownTitle": `LULxCEE2Qs7qIYOBrKMl`,
	"instructions": `fZZCjv0AxLUYfflqKsIK`,
	"navigationContainer": `IiYBf2cBYGIRCQmbdq7w`,
	"carets": `iQEdGfyR0tNMq6gcowen`,
	"hidden": `OfGH5Xi0V_2BF8thLePw`,
	"count": `sKgGZW7JMyVf0Mgw95gQ`,
	"dynamicFiltersContainer": `UBJGs1FoT8R3Jm6HOgii`,
	"dropdownContainer": `T9i1JiRyMTIoB9klP3U2`,
	"dropdownHeader": `byahJmw8hUC_rmg4tsuF`,
	"cautionCardWrapper": `UlB5YvBbbxFBoPuBhScE`,
	"infoContainer": `FNS_g_1k9c1J_n34Bdcs`,
	"cautionCard": `EC3ot3gHR3yJ506Y73cU`,
	"cautionDescription": `_1jdbylUxRFiZLUWh7RR`,
	"checkboxContainer": `vhKBV1UaLxmCV5NhQdu9`,
	"checkboxLabel": `VhjrTvREEwW_CuI8heh9`,
	"checkbox": `dlfJ8wBBMY9NxX_SOnF2`,
	"buttonContainer": `M7wy0pA46KYaaUVA2XQz`,
	"leftButtonContainer": `pPMXNOU_GjUMzJCxszHu`,
	"rightButtonContainer": `gF9fc52gP4UwAGWugM46`,
	"backButtonContainer": `yx4CpfhSf7zc8hTlrNE7`,
	"backButton": `kDIfsdMBs3GtraBBgmbI`,
	"continueButtonContainer": `QX82wSWxMtEE34cNCaLQ`,
	"continueButton": `bcvyCYmNgd73i9CWhs3x`
};
export default ___CSS_LOADER_EXPORT___;
